import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { getToasterError } from '../utils';
import { dcpcApi } from './dcpcApi';

const REPORT_FORMATS_TAG = 'ReportFormats';

dcpcApi.enhanceEndpoints({ addTagTypes: [REPORT_FORMATS_TAG] });
const reportFormatsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportFormats: builder.query({
      query: () => 'new-formats',
      providesTags: [REPORT_FORMATS_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'форматов', 'formats');
        }
      },
    }),
    getReportFormat: builder.query({
      query: (formatCode) => `format/${formatCode}`,
      providesTags: [REPORT_FORMATS_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'формата', 'format');
        }
      },
    }),
    updateReportFormat: builder.mutation({
      // id = formatCode - string
      query: ({ id, body }) => ({
        url: `format/${id || ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [REPORT_FORMATS_TAG],
    }),
  }),
});

export const {
  useGetReportFormatsQuery,
  useGetReportFormatQuery,
  useUpdateReportFormatMutation,
} = reportFormatsApi;

export const reportFormatsSelect = (state) => reportFormatsApi.endpoints.getReportFormats.select()(state);
export const reportFormatsSelector = (state) => reportFormatsSelect(state).data || [];

const filterReportFormatsBySearchTextSelector = createSelector(
  reportFormatsSelector,
  (_, searchText) => searchText,
  (reportFormats, searchText) => ({
    columns: [
      {
        label: 'Код',
      },
      {
        label: 'Описание',
      },
    ],
    rows: reportFormats.reduce((acc, cur) => {
      const { formatCode, description } = cur;
      const row = [formatCode, description].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать формат',
    },
  }),
);

export const reportFormatsBySearchTextSelector = (searchText) => (state) => filterReportFormatsBySearchTextSelector(state, searchText);
